export default Object.freeze({
  Borrador: 1,
  EnProcesoFirma: 2,
  Completada: 3,
  Cancelada: 4,
  FirmaRechazada: 5,
  DocumentoCancelado: 6,
});
